/* eslint-disable max-len */

import { SMALL_CHAIN_VENUES_NUMBER } from 'features/void-analysis/constants';

export const SCORE_PARAMS_TOOLTIP_TEXTS = {
    demographics:
        'Businesses with less than 10 locations might not have a representative demographic profile. Therefore, the demographic fit score may not accurately indicate the potential fit.',
    naturalCoTenants: `Frequent Co-Tenants score parameter is not considered for potential tenants with less than ${SMALL_CHAIN_VENUES_NUMBER} locations`,
};
